import * as Actions from './type';

import {
  AddApi,
  VerifyCoUserAPI,
  setupApi,
  getAllMechanins,
  updateWageRateApi,
  getUserApi,
  updateUserApi,
  changePasswordApi,
  getAllUsersApi,
  addUpdateGamificationDetailsApi,
  getGamificationDetailsApi,
} from '../../api/users/co-user-api';
import axios from '../../api/index';

const baseURL = '/coUSER';

export const add = (coUserData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.COUSER_ADD_REQUEST,
    });

    const { data } = await AddApi(coUserData);

    dispatch({
      type: Actions.COUSER_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.COUSER_ADD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const ConfirmCoUserAccount = (confirmationToken) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.COUSER_VERIFY_REQUEST,
    });
    const { data } = await VerifyCoUserAPI(confirmationToken);

    if (data.verified) {
      localStorage.setItem('userData', JSON.stringify(data));
      dispatch({
        type: Actions.COUSER_VERIFY_SUCCESS,
        payload: {
          verified: data.verified,
        },
      });
    } else {
      dispatch({
        type: Actions.COUSER_VERIFY_FAIL,
        payload: {
          error: data.error,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: Actions.COUSER_VERIFY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const setupAccount = (req) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.COUSER_SETUPACCOUNT_REQUEST,
    });

    const { data } = await setupApi(req);
    localStorage.clear();
    localStorage.setItem('userData', JSON.stringify(data));

    dispatch({
      type: Actions.COUSER_SETUPACCOUNT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.COUSER_SETUPACCOUNT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const GetRecentUsersList = () => async (dispatch) => {
  try {
    dispatch({ type: Actions.RECENT_COUSER_REQUEST });

    const { data } = await axios.get(`${baseURL}/get-recent-users`);

    dispatch({ type: Actions.RECENT_COUSER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: Actions.RECENT_COUSER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getMechanins = () => async (dispatch) => {
  try {
    dispatch({ type: Actions.GET_ALL_MECHANICS_REQUEST });

    const { data } = await getAllMechanins();
    dispatch({ type: Actions.GET_ALL_MECHANICS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: Actions.GET_ALL_MECHANICS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getUser = () => async (dispatch) => {
  try {
    dispatch({ type: Actions.GET_USER_REQUEST });

    const { data } = await getUserApi();
    dispatch({ type: Actions.GET_USER_SUCCESS, payload: data?.data || '' });
  } catch (error) {
    dispatch({
      type: Actions.GET_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// update user account settings

export const updateUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: Actions.UPDATE_USER_REQUEST });

    const { data } = await updateUserApi(userData);
    dispatch({
      type: Actions.UPDATE_USER_SUCCESS,
      payload: data || '',
    });

    if (userData?.usedIn === 'account') {
      dispatch({
        type: Actions.UPDATE_USER_DATA,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// change user password

export const changePassword = (passData) => async (dispatch) => {
  try {
    dispatch({ type: Actions.CHANGE_USER_PASSWORD_REQUEST });

    const { data } = await changePasswordApi(passData);
    dispatch({
      type: Actions.CHANGE_USER_PASSWORD_SUCCESS,
      payload: data?.message || '',
    });
  } catch (error) {
    dispatch({
      type: Actions.CHANGE_USER_PASSWORD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateWageRate = (wageRateDate) => async (dispatch) => {
  try {
    dispatch({ type: Actions.UPDATE_WAGE_RATE_REQUEST });

    const { data } = await updateWageRateApi(wageRateDate);
    dispatch({ type: Actions.UPDATE_WAGE_RATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: Actions.UPDATE_WAGE_RATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const GetAllUsersList = () => async (dispatch) => {
  try {
    dispatch({ type: Actions.GET_ALL_USERS_LIST_REQUEST });

    const { data } = await getAllUsersApi();

    dispatch({ type: Actions.GET_ALL_USERS_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: Actions.GET_ALL_USERS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// add /update gamification details
export const addUpdateGamificationDetails = (resource) => async (dispatch) => {
  try {
    dispatch({ type: Actions.ADD_UPDATE_GAMIFICATION_DETAILS_REQUEST });

    const { data } = await addUpdateGamificationDetailsApi(resource);
    dispatch({
      type: Actions.ADD_UPDATE_GAMIFICATION_DETAILS_SUCCESS,
      payload: data?.data || '',
    });
  } catch (error) {
    dispatch({
      type: Actions.ADD_UPDATE_GAMIFICATION_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// get gamification details
export const getGamificationDetails = () => async (dispatch) => {
  try {
    dispatch({ type: Actions.GET_GAMIFICATION_DETAILS_REQUEST });

    const { data } = await getGamificationDetailsApi();

    dispatch({
      type: Actions.GET_GAMIFICATION_DETAILS_SUCCESS,
      payload: data?.data || [],
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_GAMIFICATION_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
